import _objectSpread from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createVNode as _createVNode, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  class: "amz-van-notice-bar"
};
var _hoisted_2 = ["onClick"];
import { onMounted, ref } from 'vue';
import { useLess } from '@/models/hooks';
import { useRoute, useRouter } from 'vue-router';
import { jumpInteractionType } from '@/utils/common';
import { awsRumHandler } from '@/utils/awsRumHandler.js';
import { clickEvents } from '@/configs/awsRumConfig';
export default {
  __name: 'StoreAnnouncement',
  props: {
    properties: {
      type: Object,
      require: true,
      default: () => {
        return {
          categoryType: 'shop_notices',
          widgetCategoryTitle: 'StoreAnnouncement',
          bottomSpacing: '6',
          // Distance between components 0 6 12 20
          ceilingType: 'NOT_CEILING',
          // Ceiling mounted or not
          textColor: '#ed6a0c',
          scrollSpeed: '3000',
          backgroundColor: '#fffbe8',
          interactionTypeInfo: [{
            announcementContent: 'Hello world'
          }]
        };
      }
    }
  },
  setup(__props) {
    var props = __props;
    var route = useRoute();
    var router = useRouter();
    useLess('views/landingPage/storeAnnouncement/StoreAnnouncement.less');
    var leftIcon = ref();
    var handleJumpPage = advertisementItem => {
      jumpInteractionType(advertisementItem, router);
    };
    onMounted(() => {
      leftIcon.value = props.properties.cornerIcon || 'volume-o';
      var recordParams = {
        pageName: route.name
      };
      awsRumHandler.recordClickEvent(_objectSpread(_objectSpread({}, clickEvents.landingPage.storeAnnouncementWidget), recordParams));
    });
    return (_ctx, _cache) => {
      var _component_van_swipe_item = _resolveComponent("van-swipe-item");
      var _component_van_swipe = _resolveComponent("van-swipe");
      var _component_van_notice_bar = _resolveComponent("van-notice-bar");
      return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_van_notice_bar, {
        "left-icon": leftIcon.value,
        background: __props.properties.backgroundColor,
        scrollable: false,
        class: _normalizeClass([{
          'van-notice-bar-bottom6': __props.properties.bottomSpacing == '6'
        }, {
          'van-notice-bar-bottom12': __props.properties.bottomSpacing == '12'
        }, {
          'van-notice-bar-bottom20': __props.properties.bottomSpacing == '20'
        }])
      }, {
        default: _withCtx(() => [_createVNode(_component_van_swipe, {
          vertical: true,
          class: "notice-swipe",
          autoplay: __props.properties.scrollSpeed,
          touchable: false,
          "show-indicators": false
        }, {
          default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.properties.interactionTypeInfo, (item, index) => {
            return _openBlock(), _createBlock(_component_van_swipe_item, {
              key: index
            }, {
              default: _withCtx(() => [_createElementVNode("span", {
                style: _normalizeStyle({
                  color: `${__props.properties.textColor} !important`
                }),
                onClick: $event => handleJumpPage(item)
              }, _toDisplayString(item.announcementContent), 13, _hoisted_2)]),
              _: 2
            }, 1024);
          }), 128))]),
          _: 1
        }, 8, ["autoplay"])]),
        _: 1
      }, 8, ["left-icon", "background", "class"])]);
    };
  }
};